import gql from 'graphql-tag';

import { gql as gqlFn } from '@/graphql/__generated__';

export const ownTenantQuery = gqlFn(/* GraphQL */ `
  query tenant($id: ID!) {
    tenant(id: $id) {
      ...OwnTenant
    }
  }
`);

export const updateTenantMutation = gqlFn(/* GraphQL */ `
  mutation UpdateTenant($id: ID!, $name: String, $address: AddressInput, $image: Upload) {
    updateTenant(input: { id: $id, name: $name, address: $address, image: $image }) {
      tenant {
        ...OwnTenant
      }
    }
  }
`);

const tenantFragment = gql`
  fragment Tenant on TenantNode {
    id
    name
  }
`;

const tenantOwnFragment = gql`
  fragment OwnTenant on TenantNode {
    id
    name
    type
    logoUrl
    address {
      ...Address
    }
    createdAt
    features {
      enableProjectStructureTemplates
      enableProjectTemplates
      enableTradeTemplates
      enableTradeSequenceTemplates
    }
  }
`;
